export default __webpack_public_path__ + "static/media/icon-23.a66e87c4.png";